import request from '@/utils/request'
let dir="/CyGameBack";
// let dir=""

// // 用户获取验证码
// export const reqAuthCode = async (data) =>
// 	request.post('/vehicleclient/wechat/getVerificationCode', data)

// // 用户登录H5
// export const loginH5 = async (data) => request.post('/vehicleclient/personal/login', data)

// // 微信授权 ——预创建
// export const loginWxPre = async (data) => request.post('/vehicleclient/wechat/authorize_pre', data)

// 用户登录公众号 ——创建
export const loginWx = async (data) => request.post(dir+'/hryhUserS260507/getOpenId', data)

// 获取用户信息
export const reqUserInfo = async (data) => request.get(dir+'/hryhUserS260507/getByUser', data)


// 将用户选择的箱子ID 上传后端
export const submitAns =  (data) => request.post(dir+'/hryhUserS260507/submitAns', data)

// 分享成功，后端将抽奖次数加一
export const reqShare = async (data) => request.get(dir+'/hryhUserS260507/share', data)

// 抽奖
export const reqDraw = async (data) => request.post(dir+'/hryhUserS260507/draw', data)

// 获取微信JSSDK配置
// 设置请求体 "Content-Type": "application/x-www-form-urlencoded",
export const reqWxJsSdkConfig = async (data) => request.post('/orangeH5Back/wx/getWxAutoMessage', data, {
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
	}
})



// WEBPACK FOOTER //
// ./src/api/index.js